/**
 * Shared web shell / page horizontal insets.
 * Header logo must use the same inset as page content at every breakpoint.
 */

/** WebAppLayout shell inset — desktop / wide (≥ SHELL breakpoint). */
export const WEB_SHELL_PADDING_DESKTOP = 32;

/** WebAppLayout shell inset — medium / phone (< SHELL breakpoint). */
export const WEB_SHELL_PADDING_MOBILE = 16;

/**
 * Extra horizontal padding pages add inside the wide shell
 * (ADHA listing rows, details, etc. when sidebar is hidden).
 * Compact shell (`shellMobile`) must NOT stack this — pages use 0 extra
 * (see pageRootCompact / contentScrollMobile).
 */
export const WEB_PAGE_CONTENT_PADDING = 24;

/**
 * Vertical space between WebHeader and page body on screens that do not have
 * an in-page greeting row (unit details, home, catalogue, etc.).
 * Listing keeps a tighter inset because the greeting provides separation.
 */
export const WEB_PAGE_TOP_BELOW_HEADER = 16;

/** Shell padding for the current shell mode. */
export function getWebShellPadding(isCompactShell: boolean): number {
  return isCompactShell ? WEB_SHELL_PADDING_MOBILE : WEB_SHELL_PADDING_DESKTOP;
}

/**
 * Extra page inset inside the shell. Only on wide shell — compact pages
 * already sit flush to the 16px shell edge.
 */
export function getWebPageContentPadding(isCompactShell: boolean): number {
  return isCompactShell ? 0 : WEB_PAGE_CONTENT_PADDING;
}

/**
 * Header horizontal padding so the logo aligns with page content.
 * - Compact shell: shell only (matches ADHA compact / details mobile)
 * - Wide shell + ADHA / hideSidebar: shell + page content padding
 * - Wide shell otherwise: shell only
 */
export function getWebHeaderHorizontalPadding(
  isCompactShell: boolean,
  alignWithPageContent: boolean,
): number {
  const shell = getWebShellPadding(isCompactShell);
  if (!alignWithPageContent) {
    return shell;
  }
  return shell + getWebPageContentPadding(isCompactShell);
}
